import extractTextFromHtml from '../../../../util/extractTextAndWrapInH3';
import firstH1Element from '../../../../util/firstH1Element';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import '../css/StaffPicks.css';
import { createSlug } from '../../../../util/urlHelpers';

export const StaffPicksCardTitle = ({ cardData }) => {
  const cardId = cardData?.id;
  const title = cardData?.title;
  const firstImage = cardData?.featuredImage;
  const params = useParams();
  const lang = params?.lang;

  const history = useHistory();

  const handelClick = () => {
    history.push(`/${lang}/blog/q?&id=${cardId}${title ? '&name=' + createSlug(title) : ''}`);
  };
  return (
    <div onClick={handelClick} className="StaffPicksCardTitle">
      <img src={firstImage} alt={title} className="image_title_card" />
      <div className="container_details_title">
        <div className="small_card_title">{title}</div>
        {/* <p>by {author}</p> */}
        {/* <p>in {publication}</p> */}
      </div>
    </div>
  );
};
